import * as AlertNotification from '@givebutter/primitives/alert-notification';

const NonProfitVerificationUnderReview = () => {
    return (
        <AlertNotification.Root type="info">
            <AlertNotification.Icon />
            <AlertNotification.Content>
                <AlertNotification.Title>
                    We are reviewing your submitted documents
                </AlertNotification.Title>
                <AlertNotification.Description>
                    Please allow 1-3 business days for us to review your information. You will
                    receive a status update via email when our review is complete. In case of a
                    mistake, you can upload additional files below for review.
                </AlertNotification.Description>
            </AlertNotification.Content>
        </AlertNotification.Root>
    );
};

export { NonProfitVerificationUnderReview };
